import { ComboboxOption } from "@models/entities/general";

export const SubscriptionTypes = ['OPENING ONLINE', 'OPENING', 'BASE'];
export const SubscriptionTypesCombo: ComboboxOption[] = [
  {name: 'OPENING ONLINE', value: 'OPENING ONLINE'},
  {name: 'OPENING', value: 'OPENING'},
  {name: 'BASE', value: 'BASE'}
];
export const NewSubscriptionType = [
  'Max', 'Plus', 'Mobile experience'
];
